import React from 'react';

import { DatabaseTableSortOrder, DatabaseTablesByIdQueryVariables, DatabaseTablesByIdQuery, TablesDisplayGridRowDataFragment , DatabaseTablesByIdDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  MaxCountsResultData,
  PaginatedQueryWrapper,
  SelectionProviderChildProps
} from '../../../data-catalog-shared';
import { TablesValidSortFields } from '../sorting/sortProviders/TablesGridSortProvider';
import { getRowDataWithMaxCountsForTable } from '../table/functions/TableRowDataFunctions';
import { TablesDisplayGridRowData } from '../table/types/TablesDisplayGridRowData';
import { DatabaseTablesDisplayGrid } from './DatabaseTablesDisplayGrid';

type QueryVariables = DatabaseTablesByIdQueryVariables;
type QueryResults = DatabaseTablesByIdQuery;
type QueryResultListNode = TablesDisplayGridRowDataFragment;
type GridRowData = TablesDisplayGridRowData;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.databases && resultData.databases[0] &&
    resultData.databases[0].tablesConnection;
}

function selectMaxCountsResult(resultData: QueryResults): MaxCountsResultData {
  return resultData && resultData.databases && resultData.databases[0];
}

function getRowDataForTable(
  table: TablesDisplayGridRowDataFragment,
  resultData: QueryResults,
): TablesDisplayGridRowData {
  return getRowDataWithMaxCountsForTable(table, selectMaxCountsResult(resultData));
}

export type DatabaseTablesQueryGridProps =
  SelectionProviderChildProps &
  GridSortProps<TablesValidSortFields> & {
    readonly databaseId: string;
    readonly rowCount: number | null;
  };

export function DatabaseTablesQueryGrid(props: DatabaseTablesQueryGridProps): JSX.Element {
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={DatabaseTablesByIdDocument}
      partialQueryVariables={{
        databaseId: props.databaseId,
        orderBy: props.orderBy as DatabaseTableSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForTable}
    >
      {({ rowStore }) => (
        <DatabaseTablesDisplayGrid
          rowStore={rowStore}
          selectedKeys={props.selectedKeys}
          updateSelectionForKey={props.updateSelectionForKey}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  );
}
